export default __webpack_public_path__ + "static/media/08_photo.7d3e925e.jpg";